export const COLOR = {
    DARK_GRAY: "#cccccc",
    WHITE: "#ffffff",
    SKY_BLUE: "#379BBA",
    LIGHT_GREEN: "#73BA37",
    BLUE_HIGHLIGHT: "#376BBA",
    BLACK: "#151515",
    TRANSPARENT: "rgba(0,0,0,0)",

    // colors used for theming matchbar chips
    PALE_YELLOW : "#fff2b2",
    PALE_BLUE: "#bbedff",
    PALE_GREEN: "#d9f2e0"
}

export const STANDARD_REPORT_COLORS = {
    INSERT_DATA_ONLY: "#3CBE49",
    INSERT_DATA_INSTEAD_OF_INSERT_MODEL: "#C3E040",
    INSERT_MODEL_PLUS_DATA: "#D14AA2",
    INSERT_MODEL_PLUS_TEMPLATE_FILE_PLUS_DATA: "#D14AA2",
    DELETED: "#FF0000",
    UNDEFINED: "#CCCCCC",
    OUTDATED: "#DA9F14"
}